global.activeDashboard = function activeDashboard() {
    activeClientDashboardBoxes()
}

////COUNT TO SCAN
global.activeClientDashboardBoxes = function activeClientDashboardBoxes() {
    $(function () {
        clientDashboardBoxes()
    })

    $(document).on('app.active-client-changer', function () {
        clientDashboardBoxes()
    })

    setInterval(() => {
        clientDashboardBoxes()
    }, 120 * 1000)
}

global.clientDashboardBoxes = function clientDashboardBoxes() {
    $('#client-dashboard-boxes').load(routes['app.client.dashboard_boxes'])
}

